import { render, staticRenderFns } from "./Recurso.vue?vue&type=template&id=b611e436&scoped=true"
import script from "./Recurso.vue?vue&type=script&lang=js"
export * from "./Recurso.vue?vue&type=script&lang=js"
import style0 from "./Recurso.vue?vue&type=style&index=0&id=b611e436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b611e436",
  null
  
)

export default component.exports